import { LANGS } from "./constants";
import { buildTour, buildTourDetail } from "./helpers";

import { oneDayAestheticTour } from "./oneDayAesthetic";
import { oneSpotPhotoTour } from "./oneSpotPhoto";
import { hiddenSupTour } from "./hiddenSup";
// import { jetPrivateSecretTour } from "./jetPrivateSecret";
// import { sunsetSupTour } from './sunsetSup';
// import { yaebijiTour } from './yaebiji';
// import { influencerPromoTour } from './influencerPromo';
// import { creatorLocationTour } from './creatorLocation';
import { surfingTour } from "./surfing";

export const TOUR_LIST = [
  oneSpotPhotoTour,
  oneDayAestheticTour,
  // jetPrivateSecretTour,
  // sunsetSupTour,
  surfingTour,
  hiddenSupTour,
  // yaebijiTour,
  // influencerPromoTour,
  // creatorLocationTour,
];

export const tours = Object.fromEntries(
  LANGS.map((lang) => [lang, TOUR_LIST.map((tour) => buildTour(lang, tour))]),
);

export const tourDetails = Object.fromEntries(
  LANGS.map((lang) => [
    lang,
    Object.fromEntries(
      TOUR_LIST.filter(
        (tour) => tour.slug && tour.detail && tour.detailTexts?.[lang],
      )
        .map((tour) => [tour.slug, buildTourDetail(lang, tour)])
        .filter(([, detail]) => detail),
    ),
  ]),
);
